export default __webpack_public_path__ + "static/web/media/customer.36cf5b7a.png";